<template>
  <div class="portfolio" id="portfolio">
    <h2 class="portfolio__title">Portfolio</h2>
    <div class="portfolio__cards">
      <div class="card" v-for="card in cards" :key="card.id">
        <div class="card__text">
          <h3 class="card__title">{{ card.title }}</h3>
          <p class="card__link">
            <a :href="card.link" target="_blank">{{ card.linkText }}</a>
          </p>
          <img v-if="card.QR" :src="card.QR" alt="QR" width="80" class="QR" loading="lazy" />
        </div>

        <figure class="card__image">
          <img
            :src="card.image"
            :alt="card.title"
            width="150"
            height="100"
            loading="lazy"
          />
        </figure>
        <p class="card__description" v-html="card.description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CxPortfolio",
  props: {
    msg: String,
  },
  data() {
    return {
      cards: [
        {
          id: 0,
          title: "Arcana Astral",
          link: "https://arcanaastral.vercel.app",
          linkText: "@arcana_astral",
          image: require("../assets/images/arcanaastral.png"),
          QR: "",
          description:
            "Terápias Holisticas. Creada con <strong>Vue.js</strong> y desplegada en <strong>Vercel</strong>.",
        },
        {
          id: 1,
          title: "Jericoacoara",
          link: "https://jericoacoara.vercel.app",
          linkText: "@Jericoacoara",
          image: "../assets/images/jericoacoara.png",
          QR: "",
          description:
            "Guía de viaje y turismo en Jericoacoara, Brasil. Creada con <strong>Vue.js</strong> y desplegada en <strong>Vercel</strong>.",
        },
        {
          id: 2,
          title: "Inca Kite",
          link: "https://incakite.vercel.app",
          linkText: "@IncaKite",
          image: require("../assets/images/incakite.png"),
          QR: "",
          description:
            "Escuela de kitesurf en Jericoacoara. Creada con <strong>Vue.js</strong> y desplegada en <strong>Vercel</strong>.",
        },
        {
          id: 3,
          title: "Casa de Huéspedes",
          link: "https://casadehuespedes.vercel.app",
          linkText: "@CasaDeHuespedes",
          image: require("@/assets/images/casadehuespedes.png"),
          QR: "",
          description:
            "Página de la posada Casa de Huéspedes en Jericoacoara. Creada con <strong>Vue.js</strong> y desplegada en <strong>Vercel</strong>.",
        },
        {
          id: 14,
          title: "Feira do Mangaio",
          link: "https://feiradomangaio.vercel.app",
          linkText: "@FeiraDoMangaio",
          image: require("@/assets/images/feiradomangaio.png"),
          QR: "",
          description:
            "Página web de la Feria do Mangaio en Jericoacoara. Creada con <strong>Vue.js</strong> y desplegada en <strong>Vercel</strong>.",
        },
        {
          id: 5,
          title: "latamBrain",
          link: "https://huggingface.co/spaces/perezcatriel/data_world_jobs",
          linkText: "@latamBrain",
          image: "../assets/latamBrain.png",
          QR: "../assets/QR/qrcode_huggingface.co.png",
          description:
            "App creada para análisis laboral en IT (Industria Tecnológica). Análisis en <strong>Tableau</strong>, predicciones con ML <strong>(Machine Learning)</strong> y almacenamiento de datos en AWS <strong>(Amazon Web Services)</strong>.",
        },
        {
          id: 6,
          title: "Movies",
          link: "https://the-reviews.netlify.app/",
          linkText: "@The Reviews",
          image: "../assets/the-reviews.png",
          QR: "../assets/QR/qrcode_the-reviews.netlify.app.png",
          description:
            "Sitio web de reseñas de películas. Conexión con <strong>api</strong> y desplegado en <strong>netlify</strong>. Diseño  <strong>first mobile</strong>.",
        },
        {
          id: 7,
          title: "Mar de Cores",
          link: "https://marde-cores.onrender.com/",
          linkText: "@marde_cores",
          image: "../assets/marde_cores.png",
          QR: "../assets/QR/qrcode_mardecores.vercel.app.png",
          description:
            "Tienda de ropa Mar de Cores creada con <strong>React</strong>. Desplegada en <strong>render</strong>",
        },
        {
          id: 8,
          title: "Simon Dice",
          link: "https://perezcatriel.github.io/simon/",
          linkText: "@simon",
          image: "../assets/simon.png",
          QR: "../assets/QR/qrcode_perezcatriel.github.io.png",
          description:
            "Juego web construido con <strong>Javascript Vanila y Bootstrap</strong>. Y desplegada en <strong>Github Pages</strong>",
        },
        {
          id: 9,
          title: "Memo Test",
          link: "https://perezcatriel.github.io/memo-test/public/",
          linkText: "@memo-test",
          image: "../assets/memo-test.png",
          QR: "../assets/QR/qrcode_perezcatriel.github.io.png",
          description:
            "Juego web construido con javascript vanilla y <strong>CSS puro.</strong> Implementado en páginas de GitHub Pages.",
        },
        {
          id: 10,
          title: "Cash Flow",
          link: "https://perezcatriel.github.io/change-flow/",
          linkText: "@cash-flow",
          image: "../assets/cash-flow.png",
          QR: "../assets/QR/qrcode_perezcatriel.github.io.png",
          description:
            "Aplicación Exchange Currency. creada con <strong>tailwind</strong> y conectada a <strong>API REST</strong> de CurrencyLayer.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.portfolio {
  padding: 5px 20px 80px;
  width: 80vw;
  max-width: 1200px;
  margin: auto;
}

.portfolio__title {
  color: var(--color-accent);
  font-family: var(--font-sans);
  font-size: 4rem;
  font-weight: bold;
  margin: 30px auto;
}

.portfolio__cards {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
}

.card {
  border-radius: 10px;
  border: 3px solid var(--color-accent);
  color: var(--color-accent);
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  min-height: 330px;
}

.card:hover {
  color: var(--color-primary);
  border: 3px solid var(--color-primary);
  transform: scale(1.1);
}

.card__title {
  font-size: 1.5rem;
  font-family: var(--font-homenaje);
  text-align: center;
  margin: 10px 0 5px;
}

.card__link {
  z-index: 10;
  text-align: center;
  margin: 0px auto 30px;
  font-family: var(--font-sans);
  font-size: 1rem;
}

.card__link a {
  color: var(--color-text);
}

.card__image {
  margin-top: 0px;
  display: flex;
  justify-content: flex-end;
}

.card__image img {
  margin: -20px auto 0;
  max-width: 150px;
  max-height: 100px;
  width: auto;
  height: auto;
}

.card__description {
  max-width: 300px;
  position: relative;
  bottom: -20px;
  text-align: center;
  font-family: var(--font-sans);
  font-size: 1rem;
}

@media (min-width: 768px) {
  .portfolio__cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .card {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .card__text {
    margin: auto;
  }
}

.QR {
  margin-bottom: 30px;
}

@media (min-width: 1024px) {
  .portfolio__cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
